import React from "react";

function Node({ n }) {
  if (n.type === "diamond") {
    const { cx, cy } = n;
    const w = 120;
    const h = 100;
    const x1 = cx - w / 2;
    const y1 = cy;
    const x2 = cx;
    const y2 = cy - h / 2;
    const x3 = cx + w / 2;
    const y3 = cy;
    const x4 = cx;
    const y4 = cy + h / 2;

    return (
      <g>
        <path d={`M${x1} ${y1} L${x2} ${y2} L${x3} ${y3} L${x4} ${y4} Z`} className="arch__diamond" />
        <text x={cx} y={cy + 5} textAnchor="middle" className="arch__text">
          {n.label}
        </text>
      </g>
    );
  }

  return (
    <g>
      <rect x={n.x} y={n.y} width={n.w} height={n.h} rx="16" className="arch__box" />
      <text x={n.x + n.w / 2} y={n.y + 30} textAnchor="middle" className="arch__text">
        {n.label}
      </text>
      {n.sub ? (
        <text x={n.x + n.w / 2} y={n.y + 52} textAnchor="middle" className="arch__subtext">
          {n.sub}
        </text>
      ) : null}
      {n.sub2 ? (
        <text x={n.x + n.w / 2} y={n.y + 70} textAnchor="middle" className="arch__subtext">
          {n.sub2}
        </text>
      ) : null}
    </g>
  );
}

export default function ArchitectureDiagram({ spec }) {
  if (!spec) return null;

  return (
    <svg viewBox={spec.viewBox} className="arch__svg" role="img">
      <defs>
        <marker id="arrow" viewBox="0 0 10 10" refX="9" refY="5" markerWidth="8" markerHeight="8" orient="auto-start-reverse">
          <path d="M 0 0 L 10 5 L 0 10 z" fill="currentColor" />
        </marker>
      </defs>

      {(spec.nodes || []).map((n) => (
        <Node key={n.id} n={n} />
      ))}

      {(spec.edges || []).map((e) => (
        <g key={e.id}>
          <path d={e.d} className="arch__path" markerEnd="url(#arrow)" />
          <circle r="5" className="arch__dot">
            <animateMotion dur={`${e.dotDur || 2.5}s`} repeatCount="indefinite" path={e.d} />
          </circle>
        </g>
      ))}
    </svg>
  );
}
